import React from 'react';
import './Modal.css';

const TEXTS = {
  generations: {
    title: 'Generationslimit erreicht',
    body:  <>Zurzeit werden beim <strong>Stammbaum-Memo</strong> nur 4 Generationen unterstützt.</>,
  },
  topGeneration: {
    title: 'Oberste Generation ist voll',
    body:  <>In der obersten Generation sind beim <strong>Stammbaum-Memo</strong> höchstens 2 Einheiten möglich – also 2 Paare, 2 Einzelpersonen oder ein Paar und eine Einzelperson (z.B. beide Grosseltern-Paare).</>,
  },
};

export function LimitModal({ reason = 'generations', onClose }) {
  const t = TEXTS[reason] || TEXTS.generations;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()} style={{ padding: '32px 28px', textAlign: 'center' }}>
        <h2 style={{ marginBottom: 14, fontSize: 20, color: '#1a1a1a' }}>{t.title}</h2>
        <p style={{ color: '#333', lineHeight: 1.7, marginBottom: 14, fontSize: 15 }}>
          {t.body}
        </p>
        <p style={{ color: '#333', lineHeight: 1.7, marginBottom: 28, fontSize: 15 }}>
          Falls mehr gewünscht ist, melde dich bitte direkt bei{' '}
          <a href="mailto:stammbaum-memo@bandeleart.ch" style={{ color: '#1540dc' }}>
            stammbaum-memo@bandeleart.ch
          </a>.
        </p>
        <button className="btn btn--primary" onClick={onClose} style={{ width: '100%', fontSize: 15, padding: '12px 0', borderRadius: '8px' }}>
          Verstanden
        </button>
      </div>
    </div>
  );
}
